/* eslint-disable one-var */
(function () {
  'use strict';

  class RiskIntelligenceCtrl {
    constructor($safetyService, $window, Authenticator, Keys, ServiceVfiltro, FactoryVfiltro) {
      this.window = $window;
      this.safetyService = $safetyService;
      this.authenticator = Authenticator;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.factoryVfiltro = FactoryVfiltro;
      this.user = {};
      this.filtro = null;
      this.authenticator.getUser()
        .then(user => {
          this.user = user;
          this.initializePage();
        });
    }

    initializePage() {
      return this.initFilter()
        .then(() => this.safetyService.initialize())
        .then(() => this.loadPage());
    }

    initFilter() {
      return this.serviceVfiltro.init(this.factoryVfiltro.get([
        {
          name: 'uoId',
          key: this.keys.uo.name,
          size: 12
        },
        {
          name: 'veiculos',
          key: this.keys.veiculos.name,
          ignoreValidation: true,
          size: 12
        },
        {
          key: this.keys.usuario.name,
          size: 6
        },
        {
          key: this.keys.nivel.name,
          size: 6
        },
        {
          key: this.keys.tipos.name,
          size: 12
        },
        {
          key: this.keys.videoContext.name,
          size: 12
        }
      ])).then(filtro => {
        this.filtro = filtro;
      });
    }

    loadPage() {
      const appName = 'safetyApp',
          componentPath = './RiskIntelligencePageRoute',
          componentId = 'safety-app-risk-intelligence',
          props = this.getReactProps();

      this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
    }

    getReactProps() {
      const uo = this.filtro.find((f) => f.key === this.keys.uo.name),
          veiculos = this.filtro.find((f) => f.key === this.keys.veiculos.name),
          usuario = this.filtro.find((f) => f.key === this.keys.usuario.name),
          nivel = this.filtro.find((f) => f.key === this.keys.nivel.name),
          tipos = this.filtro.find((f) => f.key === this.keys.tipos.name),
          videoContext = this.filtro.find((f) => f.key === this.keys.videoContext.name);

      return {
        user: this.user,
        filter: {
          uoId: uo.value.id,
          veiculos: veiculos ? veiculos.values.map((v) => v.id) : [],
          usuario: usuario ? usuario.value.id : null,
          nivel: nivel ? nivel.value.id : null,
          tipos: tipos ? tipos.values.map((t) => t.id) : [],
          videoContextLabels: videoContext ? videoContext.values.map((v) => v.label) : []
        }
      };
    }
  }

  RiskIntelligenceCtrl.$inject = ['safetyService', '$window', 'Authenticator', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro'];
  angular.module('relatorios.riskIntelligence').controller('RiskIntelligenceCtrl', RiskIntelligenceCtrl);
}());
